;(function() {
  'use strict'

  angular.module('core.feed').directive('feed', feed)

  // --------------------

  /* @ngInject */
  function feed() {
    controller.$inject = ["$scope", "$state", "glDialog", "glUtils", "edgeService", "shareService", "postsService", "pageSelector"];
    return {
      restrict: 'E',
      scope: {
        data: '=',
        limit: '=',
      },
      templateUrl: 'feed.template.html',
      link: link,
      controller: controller,
    }

    function link(scope, elem) {
      elem.addClass('gl-feed')
    }

    /* @ngInject */
    function controller(
      $scope,
      $state,
      glDialog,
      glUtils,
      edgeService,
      shareService,
      postsService,
      pageSelector
    ) {
      $scope.toggleUpvote = toggleUpvote
      $scope.viewElement = viewElement
      $scope.viewDetails = viewDetails
      $scope.shareDialog = shareDialog
      $scope.share = shareService.share
      $scope.imageStyle = glUtils.imageStyle
      // $scope.viewImage = mediaView.showImage;

      function toggleUpvote(e, item) {
        e.preventDefault()
        e.stopPropagation()

        // disable while loading
        if (item.userUpvoted === true || item.userUpvoted === false) {
          return
        }

        // upvote
        if (!item.userUpvoted) {
          // instant gratification
          item.userUpvoted = true
          adjustUpvotes(item, 1)
          // create the edge
          postsService.upvote(item.object.id).then(
            function(edgeId) {
              item.userUpvoted = edgeId
            },
            function() {
              delete item.userUpvoted
              adjustUpvotes(item, -1)
            }
          )

          // downvote
        } else {
          postsService.downvote(item.userUpvoted).then(function() {
            delete item.userUpvoted
          })
          item.userUpvoted = false
          adjustUpvotes(item, -1)
        }
      }

      function adjustUpvotes(item, amount) {
        item.counts = item.counts || {}
        item.counts.upvotes = item.counts.upvotes || 0
        item.counts.upvotes += amount
        // deny < 0
        if (item.counts.upvotes < 0) {
          item.counts.upvotes = 0
        }
      }

      function viewElement(e, element, key) {
        e.preventDefault()
        e.stopPropagation()
        pageSelector.go(element[key].id)
      }

      function viewDetails(e, item) {
        e.preventDefault()
        e.stopPropagation()
        if (item.object.objectType === 'post') {
          $state.go('app.portal.message', { id: item.object.id })
        }
      }

      function shareDialog(e, item) {
        e.preventDefault()
        e.stopPropagation()
        $scope.shareFocus = item
        glDialog.show({
          templateUrl: 'feed-dialog-share.template.html',
          scope: $scope,
        })
      }
    }
  }
})()
